export default __webpack_public_path__ + "static/media/builder_dao.0ab35f05.svg";